/*
 * @Author: llh
 * @Date: 2022-03-29 15:52:21
 * @Description: 绑定在vue上的公共函数和字典项 可以直接拿来用 定义的时候$开头 方便区分
 */
export default {
  install: function (Vue) {
    // 获取字典项
    Vue.prototype.$getDict = (str) => {
      if (!str) return []
      let arr = JSON.parse(window.sessionStorage.getItem(str))
      return arr ? arr : []
    }
    // 利用key 获取对应value
    Vue.prototype.$getLocalDictFormat = (str, arr) => {
      let tmpArr = arr.filter(el => {
        return el.value == str
      })
      return tmpArr.length ? tmpArr[0].label : str
    }
    Vue.prototype.$xxjyztTypeArr = [
      { value: 0, label: "合作社" },
      { value: 1, label: "农业大户" },
      { value: 2, label: "农业企业" },
      { value: 3, label: "家庭农场" }
    ]
    // js加法  如果直接加 小数会有问题 比如0.1+0.2
    Vue.prototype.$jsAddition = (arg1, arg2) => {
      var r1, r2, m;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2))
      return ((arg1 * m + arg2 * m) / m).toFixed(2);
    }
    // 数字转中文大写
    Vue.prototype.$numberToUpperCase = (str) => {
      var num = parseFloat(str);
      var strOutput = "",
        strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
      num += "00";
      var intPos = num.indexOf('.');
      if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
      }
      strUnit = strUnit.substr(strUnit.length - num.length);
      for (var i = 0; i < num.length; i++) {
        strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
      }
      return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")
    }
    // 20190909 => 2019-09-09
    Vue.prototype.$formatDateSimple = (str) => {
      if (typeof str != 'string') return str
      if (str.indexOf('-') > -1) return str
      var seperator1 = "-";
      var year = str.substring(0, 4);
      var month = str.substring(4, 6);
      var strDate = str.substring(6, 8);
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
    // 截取日期 不要时间
    Vue.prototype.$formatDateSubstr = (str) => {
      if (typeof str != 'string') return str
      return str.substring(0, 10)
    }
    // 格式化日期为对应格式
    Vue.prototype.$formatDate = (date) => {
      let dat;
      if (date) {
        dat = new Date(date);
      } else {
        dat = new Date()
      }
      var year = dat.getFullYear();
      var mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
      var data = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();
      var hour = dat.getHours() < 10 ? "0" + (dat.getHours()) : dat.getHours();
      var min = dat.getMinutes() < 10 ? "0" + (dat.getMinutes()) : dat.getMinutes();
      var seon = dat.getSeconds() < 10 ? "0" + (dat.getSeconds()) : dat.getSeconds();

      var newDate = year + "-" + mon + "-" + data;
      return newDate;
    }
    // 获取最近一个月
    Vue.prototype.$getLatelyMonth = () => {
      var begin = new Date();
      return new Date(begin.setMonth((new Date().getMonth() - 1)));
    }
    // 数字三个一逗号
    Vue.prototype.$formatNumberComma = (str) => {
      str = str + ""
      var newStr = "";
      var count = 0;
      // 当数字是整数
      if (str.indexOf(".") == -1) {
        for (var i = str.length - 1; i >= 0; i--) {
          if (count % 3 == 0 && count != 0) {
            newStr = str.charAt(i) + "," + newStr;
          } else {
            newStr = str.charAt(i) + newStr;
          }
          count++;
        }
        str = newStr; //自动补小数点后两位
        return str + ".00";
      }
      // 当数字带有小数
      else {
        for (var i = str.indexOf(".") - 1; i >= 0; i--) {
          if (count % 3 == 0 && count != 0) {
            newStr = str.charAt(i) + "," + newStr;
          } else {
            newStr = str.charAt(i) + newStr; //逐个字符相接起来
          }
          count++;
        }
        str = newStr + (str + "00").substr((str + "00").indexOf("."), 3);
        return str;
      }
    }
    // 日期转大写
    Vue.prototype.$dateToUpperCase = (date) => {
      var chinese = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      var y, m, d;
      if (date) {
        y = new Date(date).getFullYear().toString();
        m = new Date(date).getMonth().toString();
        d = new Date(date).getDate().toString();
      } else {
        y = new Date().getFullYear().toString();
        m = new Date().getMonth().toString();
        d = new Date().getDate().toString();
      }
      m = String(Number(m) + 1) //月份加一
      let arr = []
      var result = "";
      for (var i = 0; i < y.length; i++) {
        result += chinese[y.charAt(i)];
      }
      arr[0] = result;
      if (m.length == 2) {
        if (m.charAt(1) == "0") {
          arr[1] = "壹拾"
        } else {
          arr[1] = "壹拾" + chinese[m.charAt(1)]
        }
      } else {
        arr[1] = ("零" + chinese[m.charAt(0)])
      }
      if (d.length == 2) {
        if (d.charAt(1) == "0") {
          arr[2] = (chinese[d.charAt(0)] + "拾")
        } else {
          arr[2] = chinese[d.charAt(0)] + "拾" + chinese[d.charAt(1)]
        }
      }
      else {
        arr[2] = ("零" + chinese[d.charAt(0)])
      }
      return arr
    }
  }
}